import {StackNavigationOptions} from '@react-navigation/stack';

import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';

const useCommonScreenOptions = (
  isTopLevelNavigator = false,
): StackNavigationOptions => {
  const commonScreenOptions: StackNavigationOptions = {};
  const {isWebDesktopScreen} = useWebScreenDimensions();
  if (isWebDesktopScreen || isTopLevelNavigator) {
    // re: "cardStyle: {flex: 1}". This is to get the scrolling working on Web (see links below)
    // I also removed for example the "ScrollView" on "FeedListScreen" but couldn't get it working in
    // the allotted time. Ref:
    // - React navigation v5 not scrolling in web: https://github.com/react-navigation/react-navigation/issues/8631
    // - Scrolling does not work on web when using createBottomTabNavigator: https://github.com/react-navigation/react-navigation/issues/6165
    commonScreenOptions.cardStyle = {flex: 1};
  }
  return commonScreenOptions;
};

export default useCommonScreenOptions;
